import { IonItem, IonAvatar, IonLabel, IonSkeletonText } from '@ionic/react';

import classes from './style.module.scss';

const Loader = () => {
  return (
    <IonItem color='primary' className={classes.ionItem} lines='none'>
      <IonAvatar slot='start'>
        <IonSkeletonText animated />
      </IonAvatar>
      <IonLabel>
        <div>
          <IonSkeletonText animated />
          <IonSkeletonText animated style={{ width: '40%', marginTop: 10 }} />
        </div>
      </IonLabel>
    </IonItem>
  );
};

export default Loader;
